import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { IAvailableLanguage, IDataService, IParsedDataResponse } from '../../services/data/data-service.interface';
import { BrowserWindowRef } from '../../services/window/window.service';
import moment from 'moment';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/ru';
import 'moment/locale/uk';
import { IEnvironment } from '../../services/environment/environment.interface';

@Component({
  selector: 'gtd-language-menu',
  templateUrl: './language-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageMenuComponent {
  @Input() cssClass = '';
  public currentLanguage: string;
  public globalData: IParsedDataResponse;
  public availableLanguages: IAvailableLanguage[];
  /**
   * An array containing the names of languages that are hidden from production
   * Set code like 'ru'
   */
  public hiddenLanguageFromProd: string[] = [];
  public momentLocaleCodeOverloads = {
    ua: 'uk',
  };
  constructor(
    @Inject(BrowserWindowRef) private window: BrowserWindowRef,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('IEnvironmentService') protected envService: IEnvironment
  ) {
    this.globalData = this.dataService.getData();
    this.availableLanguages = Object.values(this.globalData.available_languages);
    if (this.envService.isProduction()) {
      this.availableLanguages = this.availableLanguages.filter((lang) => !this.hiddenLanguageFromProd.includes(lang.code));
    }
    this.currentLanguage = this.globalData.current_language;
    moment.locale(this.momentLocaleCodeOverloads[this.currentLanguage] || this.currentLanguage);
  }

  public selectLanguage(language: string): void {
    moment.locale(language);
    if (language !== this.currentLanguage) {
      window.location.href = this.window.nativeWindow.location.href.replace(`/${this.currentLanguage}/`, `/${language}/`);
    }
  }
}
